import React, { useCallback } from 'react';
import cx from 'classnames';
import { ButtonIcon } from '@components';
import { Icons } from '@types';
import styles from './styles.module.scss';

type TextAreaProps = {
  className?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  classNameInner?: string;
};

const TextArea = ({
  className = '',
  label,
  placeholder = '',
  value = '',
  onChange,
  classNameInner,
}: TextAreaProps) => {
  const handleChange = (event:React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  const clearClick = useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <div
      className={cx(
        styles.wrapper,
        className,
      )}
    >
      {label && <div className={cx(styles.label)}>{label}</div>}
      <textarea
        onInput={handleChange}
        className={cx(styles.textarea, classNameInner)}
        placeholder={placeholder}
        value={value}
        contentEditable
        suppressContentEditableWarning
      />
      {value.length > 0 && (
      <ButtonIcon
        icon={Icons.close}
        className={styles.clearButton}
        onClick={clearClick}
      />
      )}
    </div>
  );
};

export { TextArea };
